import { Popup } from "../genericComponents/Popup";
import * as React from "react";
import { useRef, useEffect } from "react";
import { IAppointmentConfirmationProps } from "./Types";
import { renderConfirmedAppointmentInfo } from "./SubComponents";
import { TypeOfFinalTransaction } from "../../dtos/KioskDtos.dtos";

export const MultiSiteSuccessfulAppointmentConfirmPopup = (props: IAppointmentConfirmationProps): JSX.Element => {
    // tslint:disable-next-line: curly
    if (!props.isAppointmentConfirmed) return null;
    
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        timerRef.current = setTimeout(() => {
            props.return({} as TypeOfFinalTransaction);
        }, 20000);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [props.return]);

    return (
        <Popup
            visible={true}
            hidepopup={() => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                    timerRef.current = null;
                }
                props.return({} as TypeOfFinalTransaction);
            }}
            title={props.textString.messagesInstructions.AppointmentHasBeenConfirmedMessage}
            closeButtonText={props.textString.labels.ExitButton}
        >
            <div className="appointment-list-table" style={{ width: "100%", borderSpacing: "5px 20px" }}>
                {props.appointments.validAppointments.map((appt, index) => {
                    return renderConfirmedAppointmentInfo(index, props, appt);                     
                })}
            </div>
        </Popup>
    );
};




// WEBPACK FOOTER //
// ./src/components/AppointmentConfirmation/MultiSiteSuccessfulAppointmentConfirmPopup.tsx